import React from 'react'
import { Button, Form } from 'semantic-ui-react'

export default class ChoiceForm extends React.PureComponent {
  onChange = (field, value) => {
    const { choice, onChange } = this.props

    onChange({
      id: choice.id,
      name: choice.name,
      price: choice.price || 0,
      order: choice.order || 0,
      [field]: value,
    })

  }

  render() {
    const { choice, onRemove, isDefault, onDefaultChange, disableNameEditing } = this.props

    return (
      <div style={{ display: 'flex' }}>
        <Form.Group widths="equal" style={{ display: 'flex', flex: 1 }}>
          <Form.Input
            fluid
            label='Name'
            placeholder='e.g Bubble'
            required
            onChange={e => this.onChange('name', e.target.value)}
            value={choice.name}
            className={disableNameEditing ? 'read-only-input' : ''}
          />
          <Form.Input
            fluid
            label='Price'
            placeholder='e.g 0.5'
            type="number"
            min={0}
            step={0.01}
            required
            onChange={e => this.onChange('price', Number(e.target.value))}
            value={choice.price || 0}
          />
        </Form.Group>
        <div style={{ paddingTop: 30, marginLeft: 10 }}>
          <Form.Checkbox
            checked={isDefault}
            onChange={onDefaultChange}
            label='Default'
          />
        </div>
        <div style={{ paddingTop: 25, marginLeft: 15 }}>
          <Button as='a' icon='trash' color="red" size="tiny" onClick={onRemove} />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/forms/choiceForm.js